<script setup>
import { ref, watch } from 'vue';

import Switch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
  isEditingView: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update']);

const attributeValue = ref(Boolean(props.attribute.value));

// A chave era inicializada uma única vez. Quando o valor chegava depois da
// montagem (contato ainda carregando) ou mudava por fora da tela (outro painel,
// sincronização), ela continuava exibindo o estado antigo -- o atributo estava
// salvo e a interface mostrava o contrário.
watch(
  () => props.attribute.value,
  value => {
    attributeValue.value = Boolean(value);
  }
);

// Usa o próprio v-model em vez do payload do evento, como fazem os demais
// consumidores do Switch (AutoResolve, AudioTranscription, FeatureToggle):
// o ref já está atualizado quando o change dispara, e assim a gravação não
// depende do que o componente filho resolve emitir.
const handleChange = () => {
  const nextValue = attributeValue.value;
  if (
    props.attribute.attributeKey === 'numero_equipe' &&
    !nextValue &&
    Boolean(props.attribute.value)
  ) {
    // Keep the switch on until the shared removal confirmation succeeds.
    attributeValue.value = true;
  }
  emit('update', nextValue);
};
</script>

<template>
  <div
    class="flex items-center w-full gap-2"
    :class="{
      'justify-start': isEditingView,
      'justify-end': !isEditingView,
    }"
  >
    <Switch v-model="attributeValue" @change="handleChange" />
  </div>
</template>
